/*
 * Chaos Theme
 *
 * Use this file to add custom Javascript to the Chaos Theme.  Keeping your custom
 * Javascript in this fill will make it easier to update Chaos. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

document.addEventListener("DOMContentLoaded", async function () {
  const menuButtonAlternative = document.querySelector(
    "[data-header-menu-button-banner]"
  );

  if (menuButtonAlternative) {
    const headerElement = document.querySelector("header");
    const mainElement = document.querySelector("main");
    if (headerElement && mainElement) {
      mainElement.insertBefore(headerElement, mainElement.firstChild);
      headerElement.style.position = "fixed";
      headerElement.style.inset = "0";
    }
  }

  const ageModal = document.getElementById("ageModal");
  const hideAgeModal = window.localStorage.getItem("hideAgeModal");
  const bodyElement = document.querySelector("body");
  if (!hideAgeModal) {
    ageModal.classList.remove("hidden");
    bodyElement.style.overflow = "hidden";
    const responseCountry = await fetch(
      window.Shopify.routes.root +
        "browsing_context_suggestions.json" +
        "?country[enabled]=true" +
        `&country[exclude]=${window.Shopify.country}` +
        "&language[enabled]=true" +
        `&language[exclude]=${window.Shopify.language}`
    );
    const responseJson = await responseCountry.json();
    const country = responseJson.detected_values.country.handle;
    const responseContinents = await fetch(
      `https://restcountries.com/v3.1/alpha/${country}`
    );
    const responseJsonContinents = await responseContinents.json();
    let continents = [];
    continents = responseJsonContinents[0]?.continents || [];
    const isAsiaOrEurope =
      continents.length > 0
        ? continents.includes("Asia") || continents.includes("Europe")
        : continents.push("Europe");
    const minimalAge = isAsiaOrEurope ? 18 : 21;
    const closeAgeModalButton = ageModal.querySelector("#closeAgeModal");
    const inputsContainer = ageModal.querySelector("#year-input-container");
    const allInputs = inputsContainer.querySelectorAll("input");

    // console.log(continents);
    // console.log(country);

    allInputs.forEach((input) => {
      input.addEventListener("input", function () {
        removeErrorInput();
      });
      input.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
          closeAgeModalButton.click();
        }
      });
    });
    closeAgeModalButton.addEventListener("click", validateAge);
    function validateAge() {
      const allInputsValues = [];
      let inputYear = "";
      const currentYear = new Date().getFullYear();
      allInputs.forEach((input) => {
        allInputsValues.push(input.value);
        inputYear = `${inputYear}${input.value}`;
      });
      if (allInputsValues.includes("")) {
        addErrorInput(minimalAge);
        return;
      }
      const minimalAgeReached = currentYear - inputYear >= minimalAge;
      if (minimalAgeReached) {
        removeErrorInput();
        ageModal.style.display = "none";
        ageModal.setAttribute("aria-hidden", "true");
        window.localStorage.setItem("hideAgeModal", "true");
        bodyElement.style.overflow = "auto";
      } else {
        addErrorInput(minimalAge);
        return;
      }
    }
  } else {
    ageModal.setAttribute("aria-hidden", "false");
    ageModal.style.display = "none";
  }

  const heroImageElement = document.querySelector("[data-hero-image]");
  const imageBackgroundElement = document.querySelector("#background-image");
  const headerMenuElement = document.querySelector("[data-header-menu]");

  if (!imageBackgroundElement || !heroImageElement || !headerMenuElement)
    return;

  window.addEventListener("scroll", () => {
    const scrollY = window.scrollY;

    if (HeroImageIsOnScreen(heroImageElement)) {
      headerMenuElement.style.transform = `translateX(-50%) translateY(${
        -scrollY * 2.2
      }px)`;
      headerMenuElement.classList.remove("top-[10px]");
      headerMenuElement.classList.add("bottom-[25px]");
      imageBackgroundElement.style.filter = "none";
    } else {
      imageBackgroundElement.style.filter = `blur(${scrollY / 100}px)`;
      headerMenuElement.style.transform = `translateX(-50%)`;
      headerMenuElement.classList.add("top-[10px]");
      headerMenuElement.classList.remove("bottom-[25px]");
    }

    if (scrollY >= 1700) {
      imageBackgroundElement.style.position = "absolute";
    } else {
      imageBackgroundElement.style.position = "fixed";
    }
  });
});

function removeErrorInput() {
  const ageModal = document.getElementById("ageModal");
  const inputsContainer = ageModal.querySelector("#year-input-container");
  const allInputs = inputsContainer.querySelectorAll("input");
  const errorMessage = ageModal.querySelector("#error-message-age-popup");
  allInputs.forEach((input) => {
    input.classList.remove("error-input");
  });
  errorMessage.classList.add("hidden");
}

function addErrorInput(minimalAge) {
  const ageModal = document.getElementById("ageModal");
  const inputsContainer = ageModal.querySelector("#year-input-container");
  const allInputs = inputsContainer.querySelectorAll("input");
  const errorMessage = ageModal.querySelector("#error-message-age-popup");
  const errorMessageText = errorMessage.getAttribute("data-message");
  allInputs.forEach((input) => {
    input.classList.add("error-input");
  });
  errorMessage.classList.remove("hidden");
  errorMessage.innerHTML = errorMessageText.replace("age_limit", minimalAge);
}

function HeroImageIsOnScreen(element) {
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  const curBottom = rect.bottom;
  const isVisible = curBottom >= -10;
  return isVisible;
}
